export default "Key,Value\r\nMaxHP,800\r\nSPD,10\r\nStarterMana,55\r\nStarterSigils,0\r\nSpawnProtectSec,3\r\nNicknamePrefix,Master\r\n"